import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import {
    HomeOutlined,
    ArrowLeftOutlined,
    SearchOutlined,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import "./NotFound.scss";

const NotFound = () => {
    const navigate = useNavigate();

    const quickLinks = [
        { text: "Dashboard", path: "/", icon: <HomeOutlined /> },
        { text: "Projects", path: "/project-management", icon: <SearchOutlined /> },
        { text: "Company Directory", path: "/company-directory", icon: <QuestionCircleOutlined /> },
    ];

    return (
        <div className="not-found-container">
            <div className="not-found-wrapper">
                {/* Animated 404 Section */}
                <div className="error-code-section">
                    <div className="error-code">
                        <span className="four first">4</span>
                        <span className="zero">
                            <div className="mt-logo-circle">
                                <div className="mt-logo">MT</div>
                            </div>
                        </span>
                        <span className="four last">4</span>
                    </div>
                    <div className="error-subtitle">Page Not Found</div>
                </div>

                {/* Message Section */}
                <div className="message-section">
                    <h2 className="main-message">Oops! Looks like you're lost</h2>
                    <p className="sub-message">
                        The page you're looking for doesn't exist or has been moved.
                        <br />
                        Let's get you back on track!
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                    <Button
                        className="btn-recruit btn-primary"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => navigate(-1)}
                        size="large"
                    >
                        Go Back
                    </Button>
                    <Button
                        className="btn-recruit btn-secondary"
                        icon={<HomeOutlined />}
                        onClick={() => navigate("/")}
                        size="large"
                    >
                        Go to Dashboard
                    </Button>
                </div>

                {/* Quick Links */}
                <div className="quick-links-section">
                    <h3 className="quick-links-title">Quick Links</h3>
                    <div className="quick-links">
                        {quickLinks.map((link, index) => (
                            <div
                                key={index}
                                className="quick-link-card"
                                onClick={() => navigate(link.path)}
                            >
                                <div className="link-icon">{link.icon}</div>
                                <div className="link-text">{link.text}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Fun Facts */}
                <div className="fun-facts">
                    <div className="fun-fact-icon">💡</div>
                    <p className="fun-fact-text">
                        Did you know? Mediatropy has been transforming digital experiences since 2010!
                    </p>
                </div>
            </div>

            {/* Background Decorations */}
            <div className="background-decorations">
                <div className="decoration-circle decoration-1"></div>
                <div className="decoration-circle decoration-2"></div>
                <div className="decoration-circle decoration-3"></div>
                <div className="decoration-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
